import { ApaduaAPI } from './ApaduaAPI';

export class CompanySizeTurnoverAPI extends ApaduaAPI {
    resource: string = 'api/company-size-turnovers/';

    getCompanySizeTurnover(): Promise<Array<any>> {
        return this.get('') as any;
    }
}
